var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/modules/web.immediate.js
// module id = 438
// module chunks = 8